import React from 'react';

interface EndGameProps {
    gameOver: boolean;
    isLose: boolean;
    word: string;
    guessRows: number;
}

export default function EndGame({ isLose, gameOver, word, guessRows }: EndGameProps) {
    let isPlural = ""
    if (guessRows == 1) {
        isPlural = "guess"
    }
    else if (guessRows > 1) {
        isPlural = "guesses"
    }
    else {
        console.log("error at isPlural");
    }

    let styledWord = word.toLowerCase();
    if (gameOver){
        if (isLose) {
            return (
                <div className="popup">
                    <div className="popup-text">
                        <h1>BETTER LUCK NEXT TIME</h1>
                        <p className="word-reveal">Todays word was&nbsp;<a href={"https://www.urbandictionary.com/define.php?term="+styledWord} target="_blank" className="ud-link incorrect">{styledWord}</a>&nbsp;</p> 
                    </div>
                    <p className="word-timer">New word at Midnight PDT</p>
                </div>
            );
        } else {
            return (
                <div className="popup">
                    <div className="popup-text">
                        <h1>YOU WIN!</h1>
                        <p className="word-reveal">You got&nbsp;<a href={"https://www.urbandictionary.com/define.php?term="+styledWord} target="_blank" className="ud-link correct">{styledWord}</a>&nbsp;in {guessRows} {isPlural}!</p>
                    </div>
                    <p className="word-timer">New word at Midnight PDT</p>
                </div> 
            );   
        }
    } else {
        return (
            <div>
                {/* <p>playing</p> */}
            </div>
        )
    }
}